const PHOTO_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
export function validateReceipt(file) {
  if (!file) return 'Please upload your purchase receipt or invoice.';
  if (!PHOTO_TYPES.has(file.type) && file.type !== 'application/pdf') return 'The receipt must be a PDF, JPG, PNG or WebP file.';
  if (file.size > 4 * 1024 * 1024) return 'Please choose a receipt smaller than 4 MB.';
  return '';
}
export function validatePhotos(files) {
  if (files.length < 4) return 'Please select at least four installation photographs.';
  if (files.length > 12) return 'Please upload no more than 12 installation photographs.';
  if (files.some(file => !PHOTO_TYPES.has(file.type))) return 'Installation photos must be JPG, PNG or WebP images.';
  if (files.some(file => file.size > 25 * 1024 * 1024)) return 'Each original photograph must be smaller than 25 MB.';
  return '';
}
export function validateTotalSize(files) {
  return files.reduce((sum, file) => sum + file.size, 0) > 9.5 * 1024 * 1024
    ? 'These files are too large for email. Please choose a smaller receipt or fewer additional photographs.' : '';
}
async function resizePhoto(file, index) {
  const bitmap = await createImageBitmap(file, {imageOrientation:'from-image'});
  const scale = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff'; ctx.fillRect(0,0,canvas.width,canvas.height);
  ctx.drawImage(bitmap,0,0,canvas.width,canvas.height); bitmap.close();
  const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',.82));
  if (!blob) throw new Error('Unable to prepare a photograph. Please select a different JPG or PNG file.');
  return new File([blob], 'installation-photo-'+index+'.jpg', {type:'image/jpeg'});
}
if (typeof document !== 'undefined') {
  const form = document.getElementById('warranty-form');
  if (form) {
    const button = document.getElementById('registration-submit');
    const status = document.getElementById('registration-status');
    const requiredPhotos = [...form.querySelectorAll('[data-installation-photo]')];
    const extra = document.getElementById('extra-photos');
    const receipt = document.getElementById('purchase-receipt');
    const today = new Date();
    document.getElementById('purchase-date').max = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
    let busy = false;
    function photos() {return [...requiredPhotos.flatMap(input => [...input.files]), ...extra.files];}
    form.querySelectorAll('input[type=file]').forEach(input => input.addEventListener('change', () => {
      input.setCustomValidity('');status.textContent='';status.classList.remove('error');
      const detail = input.parentElement.querySelector('.file-detail');
      if(detail) detail.textContent=[...input.files].map(file => file.name).join(', ');
      const filled=requiredPhotos.filter(item=>item.files.length).length;
      document.getElementById('upload-total').textContent=`${filled} of 4 required photographs selected${extra.files.length ? ' · '+extra.files.length+' additional' : ''}.`;
      if(input===receipt){input.setCustomValidity(validateReceipt(input.files[0]));}
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault(); if(busy) return;
      const error = validateReceipt(receipt.files[0]) || validatePhotos(photos());
      if(error){status.textContent=error;status.classList.add('error');status.scrollIntoView({block:'center',behavior:'smooth'});return;}
      if(!form.reportValidity()) return;
      busy=true;button.disabled=true;button.textContent='Preparing files…';status.classList.remove('error');
      status.textContent='Preparing your installation photographs for email. Please keep this page open.';
      try {
        const ready=[];let i=0;
        for(const photo of photos()){ready.push(await resizePhoto(photo,++i));}
        const sizeError=validateTotalSize([receipt.files[0],...ready]);if(sizeError)throw new Error(sizeError);
        const originals=requiredPhotos.concat(extra);
        // Rebuild file controls with one uniquely named attachment per photo.
        form.querySelectorAll('[data-prepared-photo]').forEach(input=>input.remove());
        originals.forEach(input=>{input.dataset.originalName=input.name;input.removeAttribute('name');});
        ready.forEach((file,index)=>{
          const input=document.createElement('input');input.type='file';input.name='installation_photo_'+(index+1);
          input.hidden=true;input.dataset.preparedPhoto='true';const transfer=new DataTransfer();transfer.items.add(file);input.files=transfer.files;form.append(input);
        });
        const model=document.getElementById('warranty-model').value.trim().replace(/[\r\n]/g,' ');
        const serial=document.getElementById('warranty-serial').value.trim().replace(/[\r\n]/g,' ');
        document.getElementById('warranty-subject').value=`Blue Marine warranty registration | ${model} | Serial ${serial}`;
        status.textContent='Sending your registration. Complete the verification on the next page if prompted.';
        button.textContent='Sending…';HTMLFormElement.prototype.submit.call(form);
      } catch(error) {
        form.querySelectorAll('[data-original-name]').forEach(input=>{input.name=input.dataset.originalName;delete input.dataset.originalName;});
        form.querySelectorAll('[data-prepared-photo]').forEach(input=>input.remove());
        status.textContent=error.message||'We could not prepare the files. Please try again.';status.classList.add('error');button.disabled=false;button.textContent='Submit registration';busy=false;
      }
    });
    window.addEventListener('pageshow',event=>{if(event.persisted){busy=false;button.disabled=false;button.textContent='Submit registration';status.textContent='';}});
  }
}
